module.exports = __webpack_public_path__ + "img/jk_ico.3ae92b39.png";